<article class="archive-card" [class.is-preview]="preview" (click)="navigate(obj_card.id)" (keyup.enter)="navigate(obj_card.id)" [attr.tabindex]="preview ? null : 0">
  <div class="archive-card-media">
    @if (obj_card.ext == 'pdf') {
      <img [src]="thumbnails[obj_card.src!] || 'assets/img/pdfCover.png'" alt="" oncontextmenu="return false;">
    } @else {
      <img [src]="urlServerLaraApiMultimedia + obj_card.src" [alt]="obj_card.title" oncontextmenu="return false;">
    }
  </div>
  <div class="archive-card-body">
    <h3>{{ obj_card.title }}</h3>
  </div>
</article>
